import * as VueNS from "vue"

type CacheKey = string
type SetHolder = { value: Set<CacheKey> }

const createSetHolder = (): SetHolder => {
	const vue = (VueNS || {}) as { ref?: (value: Set<CacheKey>) => SetHolder; default?: { ref?: (value: Set<CacheKey>) => SetHolder } }
	const makeRef = vue.ref || vue.default?.ref
	if (typeof makeRef === "function") {
		return makeRef(new Set<CacheKey>())
	}
	return { value: new Set<CacheKey>() }
}

const pricesLoadingSet: SetHolder = createSetHolder()

export default pricesLoadingSet